import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M15 5A5 5 0 1 1 5 5a5 5 0 0 1 10 0Zm-2 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M6.14 12.506c-1.28.306-2.62.765-4.015 1.377a3.794 3.794 0 0 0-1.531 1.254C.198 15.687 0 16.351 0 17.126v2.876h11.023a6.46 6.46 0 0 1-.849-2H2v-.876c0-.419.1-.658.218-.822.187-.26.42-.454.726-.597 1.297-.567 2.517-.983 3.661-1.256a14.565 14.565 0 0 1 3.87-.396 6.5 6.5 0 0 1 1.207-1.918c-.559-.06-1.12-.09-1.682-.09-1.292 0-2.578.153-3.86.459Z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M16.5 21a4.48 4.48 0 0 0 2.396-.69l3.69 3.69L24 22.586l-3.69-3.69A4.5 4.5 0 1 0 16.5 21Zm0-2a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }